/** 业务类型 枚举值 */
export const enum BUSINESS_TYPE {
  /** 普品 */
  NORMAL = 1,
  /** 首推 */
  FIRST = 2,
  /** YQS */
  CASH_COW = 3,
  /** 集采 */
  GROUP = 4,
  /** 控销 */
  CONTROL = 5
}

/** 业务类型 */
export const BUSINESS_TYPE_VALUE_LABEL = {
  [BUSINESS_TYPE.NORMAL]: '普品',
  [BUSINESS_TYPE.FIRST]: '首推',
  [BUSINESS_TYPE.CASH_COW]: 'YQS',
  [BUSINESS_TYPE.GROUP]: '集采',
  [BUSINESS_TYPE.CONTROL]: '控销'
}
/** 业务类型 - 标签样式配置 */
export const BUSINESS_TYPE_VALUE_TAG_STYLE = {
  [BUSINESS_TYPE.NORMAL]: { color: '#52C41A', bg: '#EDFBE6' },
  [BUSINESS_TYPE.FIRST]: { color: '#FF820D', bg: '#FFE8D2' },
  [BUSINESS_TYPE.CASH_COW]: { color: '#F2AE00', bg: '#FFF4D8' },
  [BUSINESS_TYPE.GROUP]: { color: '#2784FF', bg: '#E4F0FF' },
  [BUSINESS_TYPE.CONTROL]: { color: '#0FABEE', bg: '#DEF5FF' }
}

/** 业务类型下拉列表 */
export const BUSINESS_TYPE_OPTIONS = [
  {
    label: '普品',
    value: BUSINESS_TYPE.NORMAL
  },
  {
    label: '首推',
    value: BUSINESS_TYPE.FIRST
  },
  {
    label: 'YQS',
    value: BUSINESS_TYPE.CASH_COW
  },
  {
    label: '集采',
    value: BUSINESS_TYPE.GROUP
  },
  {
    label: '控销',
    value: BUSINESS_TYPE.CONTROL
  }
]

export const enum DIALOG_BUSINESS_TYPE {
  /** 全部 */
  ALL = '0',
  /** 自营 */
  SELF_SUPPLIED = '1',
  /** YQS */
  CASH_COW = '2'
}

export const DIALOG_BUSINESS_TYPE_OPTIONS = [
  { value: DIALOG_BUSINESS_TYPE.ALL, label: '全部' },
  { value: DIALOG_BUSINESS_TYPE.SELF_SUPPLIED, label: '自营' },
  { value: DIALOG_BUSINESS_TYPE.CASH_COW, label: 'YQS' }
]

/** SRM角色类型 */
export enum SRM_ROLE_TYPE {
  /** 无 */
  'NONE' = '0',
  /** 管理员 */
  'ADMIN' = '1',
  /** 业务 */
  'BUSINESS' = '2',
  /** 财务 */
  'FINANCE' = '3',
  /** 质量 */
  'QUALITY' = '4'
}

/** SRM角色选项 */
export const SRM_ROLE_OPTIONS = [
  { value: SRM_ROLE_TYPE.NONE, label: '无' },
  { value: SRM_ROLE_TYPE.ADMIN, label: '管理员' },
  { value: SRM_ROLE_TYPE.FINANCE, label: '财务' },
  { value: SRM_ROLE_TYPE.BUSINESS, label: '业务' },
  { value: SRM_ROLE_TYPE.QUALITY, label: '质量' }
]
